import Vue from 'vue'

import * as types from '../mutation-types'

const state = {
  data: {},
  callbacks: {},
  creatingComment: false
}

const getters = {
  componentGetValue: (state) => (key, stateObjectKey) => {
    if (stateObjectKey) {
      return state.data[stateObjectKey] !== undefined && state.data[stateObjectKey][key] !== undefined ? state.data[stateObjectKey][key] : null
    }

    return state.data[key]
  },
  componentGetCallback: (state) => (key, stateObjectKey) => {
    let callback = null
    if (stateObjectKey) {
      callback = state.callbacks[stateObjectKey] !== undefined && state.callbacks[stateObjectKey][key] !== undefined ? state.callbacks[stateObjectKey][key] : null
    } else {
      callback = state.callbacks[key]
    }

    return typeof callback === 'function' ? callback : null
  }
}

const actions = {}

const mutations = {
  [types.COMPONENT_ADD] (state, params) {
    if (params.stateObjectKey) {
      if (!state.data[params.stateObjectKey]) {
        Vue.set(state.data, params.stateObjectKey, {})
      }

      Vue.set(state.data[params.stateObjectKey], params.key, params.value)
    } else {
      Vue.set(state.data, params.key, params.value)
    }

    state.data = { ...state.data }
  },
  [types.COMPONENT_DEL] (state, params) {
    if (params.stateObjectKey) {
      if (state.data[params.stateObjectKey]) {
        Vue.delete(state.data[params.stateObjectKey], params.key)
      }
    } else {
      Vue.delete(state.data, params.key)
    }

    state.data = { ...state.data }
  },
  [types.COMPONENT_PUSH] (state, params) {
    if (params.stateObjectKey) {
      if (!state.data[params.stateObjectKey]) {
        Vue.set(state.data, params.stateObjectKey, {})
      }

      if (!state.data[params.stateObjectKey][params.key]) {
        state.data[params.stateObjectKey][params.key] = []
      }

      state.data[params.stateObjectKey][params.key].push(params.value)
    } else {
      if (!state.data[params.key]) {
        state.data[params.key] = []
      }

      state.data[params.key].push(params.value)
    }

    state.data = { ...state.data }
  },
  [types.COMPONENT_POP] (state, params) {
    let updated = false

    if (params.stateObjectKey) {
      if (state.data[params.stateObjectKey] && state.data[params.stateObjectKey][params.key]) {
        if (Array.isArray(state.data[params.stateObjectKey][params.key])) {
          state.data[params.stateObjectKey][params.key].pop()
          updated = true
        }
      }
    } else if (state.data[params.key]) {
      if (Array.isArray(state.data[params.key])) {
        state.data[params.key].pop()
        updated = true
      }
    }

    if (updated) {
      state.data = { ...state.data }
    }
  },
  [types.COMPONENT_CALLBACK] (state, params) {
    if (params.stateObjectKey) {
      if (!state.callbacks[params.stateObjectKey]) {
        state.callbacks[params.stateObjectKey] = {}
      }
      state.callbacks[params.stateObjectKey][params.key] = params.callback
    } else {
      state.callbacks[params.key] = params.callback
    }
  },
  [types.COMPONENT_CALLBACK_DEL] (state, params) {
    if (params.stateObjectKey) {
      delete state.callbacks[params.stateObjectKey]
    } else {
      delete state.callbacks[params.key]
    }
  },
  [types.UPDATE_CREATING_COMMENT] (state) {
    state.creatingComment = true
  },
  [types.RESET_ON_LOGOUT] (state) {
    if (!state.creatingComment) {
      Object.keys(state.data).forEach((key) => {
        delete state.data[key]
      })
    }
    state.creatingComment = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
